//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'QuestionsList',
  data() {
    return {
      activeIndex: null,
      list: []
    }
  },
  components: {
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted() {
    this.getHospitalQuestions()
  },
  methods: {
    getDate (createdAt) {
      return moment(createdAt).format('YYYY-MM-DD HH:mm')
    },
    getHospitalQuestions () {
      this.$store.httpDispatch({})('getHospitalQuestions')
      .then((res) => {
        if (res.data.code === 0) {
          this.list = res.data.data.questions
        }
      })
    }
  }
}
